<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse">
        <ButtonComp @click="showDeleteItems" text-button="Eliminar" iconBut="fas fa-trash-alt" classColor="red"
          classButton="mx-2" normal-button />
        <ButtonComp @click="addItem" text-button="Agregar" iconBut="fas fa-plus" normal-button />
      </v-col>
      <v-col cols="12">
        <ComundataTablecomp :headers="TalonariotesoreriaHeaders" :items="listItems" :search="search"
          v-model="selectedItems" itemkey="id_config_talonario" whitSearch whitSelect
          noResultsText="Sin registros agregados">
          <template v-slot:action_editar="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" editButton tooltipText="Editar registro de talonario"
              @click="editItem(item)" />
          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>

    <!-- consultar -->


    <!-- Modal -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="showDialog" maxWidth="600" :title="formTitle" @close-modal="showDialog = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <AutocompleteComp text-label="Tipo de documento" v-model="editedItem.id_tipo_documento"
                :items="listaTipoDocumentosModal" item-value="id_tipo_documento" item-text="nombre_tipo_documento"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <textfieldComp text-label="Serie" type="text" v-model="editedItem.serie"
                :rules="validationRules.validateCuentas" />
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <textfieldComp text-label="Número" type="number" v-model="editedItem.numero"
                :rules="validationRules.validateCuentas" />

            </v-col>

            <v-col cols="6" sm="6" md="6">
              <textfieldComp text-label="Código Sunat" type="text" v-model="editedItem.codigo_sunat"
                :rules="validationRules.max20" />
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <textfieldComp text-label="Descripción" textArea type="text" v-model="editedItem.descripcion"
                :rules="validationRules.max100" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp :disabled="btnIsSaving" @click="saveItem(editedItem ? editedItem.id_config_talonario : 0)"
            :textButton="isNew ? 'Guardar' : 'Guardar Cambios'" iconBut="fas fa-save" normalButton />
          <ButtonComp @click="showDialog = false" textButton="Cancelar" classColor="red" classButton="mx-2"
            normal-button />
        </template>
      </ComunDialogComp>

    </v-form>

    <confirm @aceptar="deleteItems" titleWindow="Eliminar registro" @cancelar="cancelDelete" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import { mapMutations, mapGetters, mapActions } from "vuex";
import textfieldComp from "../../../../components/ComponentsEst/textfieldComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import { validationRules } from "../../../../helpers/validatorHelpers";
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import { TalonariotesoreriaHeaders } from '../../../../helpers/headersTable';

export default {
  components: {
    ComunDialogComp,
    ComundataTablecomp,
    ButtonComp,
    AutocompleteComp,
    textfieldComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 3, id_modulo: 4 },
    dataSession: sessionStorage,
    TalonariotesoreriaHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    listItems: [],
    lista_tipo_documentos: [],
    isNew: true,
    editedItem: {},
  }),

  computed: {
    validationRules() {
      return validationRules
    },

    formTitle() {
      return this.isNew ? "Registro de talonario" : "Editar registro de talonario";
    },
    listaTipoDocumentosModal() {
      return this.lista_tipo_documentos;
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaConfigTalonarios();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    async showDeleteItems() {
      if (this.selectedItems.length > 0) {
        this.confirm.id = 0;
        this.confirm.title = "¿Está seguro de borrar los registros seleccionados?";
        this.confirm.active = true;
      }
    },

    cancelDelete() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    async limpiarForm() {
      this.editedItem = {};
      this.$refs.formDatos.resetValidation();
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.btnIsSaving = false;
      this.isNew = true;
      await this.getListaTipoDocumentos();
      this.showDialog = true;
      this.limpiarForm();
    },

    //--------------EDITAR REGISTRO--------------
    async editItem(item) {
      console.log(item);
      this.btnIsSaving = false;
      this.isNew = false;
      await this.getListaTipoDocumentos();
      await this.getConfigTalonarioById(item.id_config_talonario);
      this.showDialog = true;
    },



    getListaTipoDocumentos() {
      axios
        .get("/tesoreria/common/tipo_documento")
        .then((response) => {
          this.lista_tipo_documentos = response.data;
          console.log(this.lista_tipo_documentos);
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    async getListaConfigTalonarios() {
      this.selectedItems = [];
      const params = { id_colegio: this.dataSession.id_colegio };
      await axios
        .post("/tesoreria/configuracion/talonario/consulta", params)
        .then((response) => {
          this.listItems = response.data.map(c => {
            c.nombre_tipo_documento = c.ck1_teso_tipo_documento.nombre_tipo_documento;
            return c;
          });
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
        });
    },

    getConfigTalonarioById(id) {
      axios
        .get("/tesoreria/configuracion/talonario/" + id)
        .then((response) => {
          this.editedItem = response.data;
          console.log('editedItem', this.editedItem);
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
        });
    },

    async saveItem(id = 0) {
      if (this.$refs.formDatos.validate()) {
        this.btnIsSaving = true;
        try {
          let response;
          const params = Object.assign({}, this.editedItem);
          params["user_id"] = this.dataSession.id;
          params["colegio_id"] = this.dataSession.id_colegio;
          if (this.isNew) {
            response = await axios.post("/tesoreria/configuracion/talonario", params);
          } else {
            response = await axios.put("/tesoreria/configuracion/talonario/" + id, params);
          }

          this.showDialog = false;
          this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });
          this.limpiarForm();
          this.getListaConfigTalonarios();
        }
        catch (error) {
          this.btnIsSaving = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },


    async deleteItems() {
      try {
        const params = { "user_id": this.dataSession.id };
        params["items"] = this.selectedItems.map(x => ({ id_config_talonario: x.id_config_talonario }));
        console.log(params);


        let response = await axios.post("/tesoreria/configuracion/talonario/delete_batch", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
          console.log(response);
        }
        else {
          this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });
          this.showDialog = false;
          this.cancelDelete();
          this.getListaConfigTalonarios();
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },
  },
};
</script>